var React = require('react');

function Plane (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.714.1.413,8.932a.793.793,0,0,0,.073,1.426L3.995,11.83l9.484-8.358a.2.2,0,0,1,.284.274L5.81,13.435v2.657a.792.792,0,0,0,1.4.522l2.1-2.552,4.113,1.723a.794.794,0,0,0,1.089-.6L16.889.923A.792.792,0,0,0,15.714.1Z","transform":"translate(-0.001 0.002)"}));
}

Plane.defaultProps = {"width":"16.9","height":"16.905","viewBox":"0 0 16.9 16.905"};

module.exports = Plane;

Plane.default = Plane;
